/* oxlint-disable */
'use client';

import React, { useEffect, useState } from 'react';

import { NextPage } from 'next';

import Image from 'next/image';

import { motion } from 'framer-motion';

import { MarketingRegisterMethods } from '@/features/v2/auth/register/MarketingRegisterMethods';

import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Separator } from '@/components/ui/separator';

/* import banpais from '@/public/img/footer/banpais.png'; */
import bitcoin from '@/public/img/footer/bitcoin.webp';

import tigo from '@/public/img/footer/tigo.png';
import visamaster from '@/public/img/footer/visamaster.png';

import {
  IconBall,
  IconDice,
  IconTrash,
} from '@/public/img/marketing/promotions';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';

import './Styles.css';

declare global {
  interface Window {
    srtmCommands?: {
      push: (command: { event: string; payload: any }) => void;
    };
  }
}

const LandingTab: NextPage = () => {
  const [timeLeft, setTimeLeft] = useState(6 * 60);
  const [welcomeBonus, setWelcomeBonus] = useState<string | null>(null);

  const diceVariants = {
    initial: { rotate: 0 },
    animate: {
      rotate: [0, 360, 720, 1080, 1440, 1800, 1440, 1080, 720, 360, 0],
      transition: {
        duration: 9,
        ease: [0.83, 0, 0.17, 1],
        repeat: Infinity,
        repeatType: 'loop' as const,
      },
    },
  };

  const footballVariants = {
    initial: { y: 0 },
    animate: {
      y: [0, -7, 10],
      transition: {
        duration: 1,
        repeat: Infinity,
        repeatType: 'loop' as const,
      },
    },
  };

  useEffect(() => {
    if (timeLeft > 0) {
      const interval = setInterval(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
      return () => {
        return clearInterval(interval);
      };
    }
    return () => {
      return undefined;
    };
  }, [timeLeft]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return (
    <div className="grid">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-0! auto-rows-auto md:min-h-screen! bgMarketing">
        {/* ============================== Chronometer ============================== */}
        <div className="row-span-1  md:row-span-2 mb-2 md:mt-[-50%]">

          <div className="flex items-center justify-center mt-[-10px] md:mt-[-48%] gap-4">
            <div className="bg-sivarbet-secondary-bg rounded-sm p-2 h-[60px] w-[60px]  text-sivarbet-secondary font-bold text-2xl">
              <p className="text-center text-sivarbet-secondary font-bold text-2xl">
                {minutes}
              </p>
              <p className="text-center text-sivarbet-text  text-[9px] mt-[-10px]">
                MIN
              </p>
            </div>
            <div className="bg-sivarbet-secondary-bg rounded-sm p-2 h-[60px] w-[60px]  text-sivarbet-secondary font-bold text-2xl">
              <p className="text-center text-sivarbet-secondary font-bold text-2xl">
                {seconds}
              </p>
              <p className="text-center text-sivarbet-text  text-[9px] mt-[-10px]">
                SEC
              </p>
            </div>
          </div>
        </div>

        {/* ============================== Register Form ============================== */}
        <div className="row-span-1  row-start-4 md:row-span-3 md:row-start-3 mt-6 md:mt-[-40%]">
          <div className="w-full md:w-2/3 mx-auto wrapper-form">
            <div className="w-full px-4">
              <Accordion type="single" collapsible className="w-full mb-4" defaultValue="item-1">
                <AccordionItem value="item-1">
                  <AccordionTrigger className="text-sivarbet-text font-medium">
                    ¿Quieres escoger un regalo?
                  </AccordionTrigger>
                  <AccordionContent>
                    <RadioGroup value={welcomeBonus || ''} onValueChange={setWelcomeBonus} className="space-y-2">
                      <div className="flex items-center justify-between p-4 rounded-lg border border-sivarbet-border bg-sivarbet-background h-[60px]">
                        <div className="flex items-center space-x-2">
                          <motion.div
                            variants={diceVariants}
                            initial="initial"
                            animate="animate"
                          >
                            <Image
                              src={IconDice}
                              alt="IconBall"
                              width={20}
                              height={20}
                            />
                          </motion.div>
                        </div>
                        <Label htmlFor="casino" className="grow ml-2">
                          <span className="text-xs text-gray-600 block">
                            Casino
                          </span>
                          100 Giros Gratis!
                        </Label>
                        <RadioGroupItem
                          value="casino"
                          id="casino"
                          className="border-sivarbet-primary text-sivarbet-primary"
                        />
                      </div>

                      <div className="flex items-center justify-between p-4 rounded-lg border border-sivarbet-border bg-sivarbet-background h-[60px]">
                        <div className="flex items-center space-x-2">
                          <motion.div variants={footballVariants} initial="initial" animate="animate">
                            <Image src={IconBall} alt="IconBall" width={20} height={20} />
                          </motion.div>
                        </div>
                        <Label htmlFor="sports" className="grow ml-2">
                          <span className="text-xs text-gray-600 block">Deportivas</span>
                          Pronostico Gratis!
                        </Label>
                        <RadioGroupItem value="sports" id="sports" className="border-sivarbet-primary text-sivarbet-primary" />
                      </div>

                      <div className="flex items-center justify-between p-4 rounded-lg border border-sivarbet-border bg-sivarbet-background h-[60px] mb-4">
                        <div className="flex items-center space-x-2">
                          <Image src={IconTrash} alt="IconTrash" width={20} height={20} />
                        </div>
                        <Label htmlFor="none" className="grow ml-2">No quiero un bono de bienvenida</Label>
                        <RadioGroupItem value="none" id="none" className="border-sivarbet-primary text-sivarbet-primary" />
                      </div>
                    </RadioGroup>
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>
            <MarketingRegisterMethods
              welcomeBonus={welcomeBonus || ''}
            />
          </div>
        </div>
        {/* ============================== Animate images ============================== */}

        {/* ============================== Bono and bono100 images ============================== */}

        {/* ============================== Footer Sponsors ============================== */}
        <div className="row-start-6 ms-5 mt-4 md:mt-10">
          <div className="flex flex-row flex-wrap justify-evenly items-center mt-1  gap-7 max-md:gap-3">
            <Image
              src={tigo}
              alt="Tigo"
              width={80}
              height={30}
              className="lg:scale-100 object-fill max-lg:max-w-[70px] max-md:max-w-[60px]"
            />

            <Image
              src={bitcoin}
              alt="Criptos"
              width={85}
              height={40}
              className="lg:scale-95 object-contain max-lg:max-w-[60px] max-md:max-w-[60px]"
            />

            <Image
              src={visamaster}
              alt="Visa Master"
              width={80}
              height={60}
              className="lg:scale-125 object-fill max-lg:max-w-[70px] max-md:max-w-[60px]"
            />
          </div>
          <Separator className="bg-sivarbet-border my-2" />

        </div>
        {/* ============================== Footer Liga ============================== */}
      </div>
    </div>
  );
};

export default LandingTab;
